import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Investment } from '../../../types/investment/Investment'
import { deleteInvestment } from '../service/investmentService'
import { useInvestmentOptions } from './useInvestment'
import { investmentQueryKeys } from '../queries/investmentQueryKeys'
import { filtersSelector } from '../../../redux/context/filters/selectors'

export const useDeleteInvestment = (isExisting: boolean) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const options = useInvestmentOptions(isExisting)
  const { message } = App.useApp()
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationFn: (investment: Investment) => deleteInvestment(companyId, investment),
    mutationKey: ['budget', 'investment', 'delete'],
    onSuccess: (_, investment) => {
      message.success(t('messages:deleteSuccess', 'Success'))
      // Invalidate investment page queries
      queryClient.invalidateQueries({ queryKey: options.queryKey })
      queryClient.invalidateQueries({
        queryKey: investmentQueryKeys.report({
          accountCode: investment.accountCode,
          budgetingScenarioId: budgetingScenario?.id
        })
      })
      // Note: Financial statements invalidation is handled by global mutation observer
    }
  })
}
